<template>
  <div id="Battletrip">
    <div class="battletrip_main_img_wrap">
      <img class="main_pc" src="../assets/img/battletrip/battletrip_main.jpg" alt="">
      <img class="main_mo" src="../assets/img/battletrip/battletrip_main_mo.jpg" alt="">
    </div>
    <div class="battletrip_point_wrap">
      <img class="section1_title" src="../assets/img/battletrip/battle_section1_title.png" alt="">
      <div class="battletrip_point">
        <img src="../assets/img/battletrip/battle_section1_item1.png" alt="">
        <img src="../assets/img/battletrip/battle_section1_item2.png" alt="">
        <img src="../assets/img/battletrip/battle_section1_item3.png" alt="">
        <img src="../assets/img/battletrip/battle_section1_item4.png" alt="">
      </div>
      <img class="section1_bg" src="../assets/img/battletrip/battletrip_section1.jpg" alt="">
    </div>
    <div class="battletrip_map_wrap bferry">
      <img class="section2_left" src="../assets/img/battletrip/battletrip_section2_left.png" alt="">
      <img class="section_bg main_pc" src="../assets/img/battletrip/battletrip_section2-1.jpg" alt="">
      <img class="section_bg main_mo" src="../assets/img/battletrip/battletrip_section2_mo.jpg" alt="">
    </div>
    <div class="battletrip_tour_wrap">
      <img class="section3_title" src="../assets/img/battletrip/battle_section3_title.png" alt="">
      <div class="battletrip_tour">
        <img src="../assets/img/battletrip/battle_section3_item1.png" @click="goToDetail('F-2521940LHC','L')" alt="">
        <img src="../assets/img/battletrip/battle_section3_item2.png" @click="goToDetail('L-2024312-1710224515956','L')" alt="">
        <img src="../assets/img/battletrip/battle_section3_item3.png" @click="goToDetail('L-2025324-1742803712116','L')" alt="">
        <img src="../assets/img/battletrip/battle_section3_item4.png"  onclick="location.href='/membershipPage'" alt="">
      </div>
    </div>
    <div class="battletrip_schedule_wrap">
      <img class="section4_title bukwan" src="../assets/img/battletrip/battle_section4_title.png" alt="">
      <div class="battletrip_schedule">
        <a
          class="schedule_box"
          :class="{ active: activeTab === 'total' }"
          @click.prevent="activeTab = 'total'; isOpenFull = false"
          href=""
        > <span class="mo_no">전체 일정</span> 
        <img class="main_mo mo_button" src="../assets/img/battletrip/mo_button1.png" alt="">
        </a>
        <a
          class="schedule_box"
          :class="{ active: activeTab === 'beppu' }"
          @click.prevent="activeTab = 'beppu'; isOpenFull = false"
          href=""
        ><span class="mo_no"> 유후인 벳푸 버스투어 자세히 보기</span>
        <img class="main_mo mo_button" src="../assets/img/battletrip/mo_button2.png" alt="">
        </a>
        <a
          class="schedule_box"
          :class="{ active: activeTab === 'yamaguchi' }"
          @click.prevent="activeTab = 'yamaguchi'; isOpenFull = false"
          href=""
        ><span class="mo_no">야마구치 버스투어 자세히 보기</span>
        <img class="main_mo mo_button" src="../assets/img/battletrip/mo_button3.png" alt="">
        </a>
      </div>
    </div>

    <div class="battletrip_schedule_page_wrap" :class="{ open: isOpenFull }">
<!--       <div class="page_open" @click="isOpenFull = true" v-if="!isOpenFull">
        <img src="../assets/img/battletrip/page_open.jpg" alt="">
      </div> -->

      <!-- 펼쳐진 상태에서도 activeTab 에 따라 한 장만 -->
      <div class="schedule_page_margin" v-if="isOpenFull">
        <img
          class="schedule_page"
          v-if="activeTab === 'total'"
          src="../assets/img/battletrip/schedule_page1.jpg"
          alt=""
        >
        <img
          class="schedule_page"
          v-if="activeTab === 'beppu'"
          src="../assets/img/battletrip/schedule_page2.jpg"
          alt=""
        >
        <img
          class="schedule_page"
          v-if="activeTab === 'yamaguchi'"
          src="../assets/img/battletrip/schedule_page3.jpg"
          alt=""
        >
<!--         <div class="page_close" @click="isOpenFull = false,scrollToSection('bukwan')">
          닫기
        </div> -->
      </div>

      <!-- 닫힌 상태일 때도 마찬가지 -->
      <div v-else>
        <img
          class="schedule_page"
          v-if="activeTab === 'total'"
          src="../assets/img/battletrip/schedule_page1.jpg"
          alt=""
        >
        <img
          class="schedule_page"
          v-if="activeTab === 'beppu'"
          src="../assets/img/battletrip/schedule_page2.jpg"
          alt=""
        >
        <img
          class="schedule_page"
          v-if="activeTab === 'yamaguchi'"
          src="../assets/img/battletrip/schedule_page3.jpg"
          alt=""
        >
      </div>
    </div>
    
    <div class="battletrip_bottom_go">
      <a href="/shiptour">승선권 모아보기</a>
    </div>
  </div>
</template>
  
<script>
export default {
  data() {
    return {
      activeTab: 'total',
      isOpenFull: false,
    };
  },
  methods: {
  goToDetail(productId, salesRoute) {
    this.$router.push({ path: '/detail', query: { productId, salesRoute } });
  },
  scrollToSection(id) {
    const el = document.querySelector(`.${id}`);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  },
  
  
  
},

};
</script>
  
<style scoped>
#Battletrip{
  margin-top: -56px;
}

.battletrip_main_img_wrap{
  width: 100%;
  height: auto;
}
.battletrip_main_img_wrap img{
  width: 100%;
}
.battletrip_top_category_wrap{
  position: sticky;
  z-index: 1000;
  width: 100%;
  height: 80px;
  background-color: #4774cf;
  display: flex;
  justify-content: center;
}
.battletrip_top_category{
  display: flex;
  background-color: #000b22;
  width: 600px;
  height: 80px;
  justify-content: center;
  
}
.battletrip_top_category a{
  width: 300px;
  height: 80px;
  background-color: #335cb0;
  transition: all 0.3s;
  text-align: center;
  color: #fff;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 1.2;
  padding-top: 1rem;
}
.battletrip_top_category a:hover{
  background-color: #244484;
}
.battletrip_point_wrap{
  width: 100%;
  position: relative;
}
.battletrip_point{
  width: 1200px;
  /*background-color: #fff;*/
  height: 300px;
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%);
  display: flex;
  justify-content: space-between;
}
.battletrip_point img{
  width: 24%;
  transition: all 0.3s;
}
.battletrip_point img:hover{
  transform: translateY(-5px);
  transform: scale(1.1);
}
.section1_title{
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translate(-50%);
  width: 23%;
}
.section1_bg{
  width: 100%;
}
.battletrip_map_wrap{
  position: relative;
  width: 100%;
}
.section_bg{
  width: 100%;
}
.section2_left{
  position: absolute;
  width: 30%;
  top: 28%;
  left: 20%;
  transition: all 0.3s;
}
.section2_left:hover{
  transform: translateY(-5px);
}
.section3_title{
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translate(-50%);
  width: 17%;
}
.battletrip_tour_wrap{
  width: 100%;
  position: relative;
  height: 1050px;
}
.battletrip_tour{
  width: 1200px;
  /*background-color: #fff;*/
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%);
  display: flex;
  justify-content: space-between;
}
.battletrip_tour img{
  width: 24%;
  transition: all 0.3s;
  height: 49%;
}
.battletrip_tour img:hover{
  transform: translateY(-5px);
}
.battletrip_schedule_wrap{
  position: relative;
  width: 100%;
  height: 300px;
}
.section4_title{
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translate(-50%);
  width: 20%;
}
.battletrip_schedule{
  width: 1200px;
  /*background-color: #fff;*/
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%);
  display: flex;
  justify-content: space-between;
}
.schedule_box{
  display: block;
  width: 399px;
  height: 80px;
  background-color: #335cb0;
  text-align: center;
  padding-top: 1.5rem;
  font-size: 1.2rem;
  font-weight: bold;
  color: #fff;
  border-radius: 10px;
  transition: all 0.3s;
}
.schedule_box:hover{
  background-color: #244484;
}
.battletrip_schedule_page_wrap{
  width: 1100px;
  position: relative;
  margin: 0 auto;
  background-color: #244484;
  height: 800px;
  overflow: hidden;
  box-shadow: 2px 2px 5px 0px rgba(0, 0, 0, 0.5);
  margin-bottom: 150px;
}
.page_open{
position: absolute;
bottom: 0%;
left: 0%;
cursor: pointer;
}
.battletrip_schedule_wrap {
  position: relative;
  width: 100%;
  height: 300px;
}
.section4_title {
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translate(-50%);
  width: 20%;
}
.battletrip_schedule {
  width: 1000px;
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%);
  display: flex;
  justify-content: space-between;
}
.schedule_box {
  display: block;
  width: 332px;
  height: 80px;
  background-color: #335cb0;
  text-align: center;
  padding-top: 1.5rem;
  font-size: 1.2rem;
  font-weight: bold;
  color: #fff;
  border-radius: 10px;
  transition: all 0.3s;
}
.schedule_box:hover {
  background-color: #244484;
}
.schedule_box.active {
  background-color: #122a5c;
}
.battletrip_schedule_page_wrap {
  width: 700px;
  position: relative;
  margin: 0 auto;
  background-color: #244484;
  height: auto;
  overflow: visible;
  box-shadow: 2px 2px 5px 0px rgba(0, 0, 0, 0.5);
  margin-bottom: 150px;
}
/* .battletrip_schedule_page_wrap.open {
  height: auto;
  overflow: visible;
  background-color: transparent;
  box-shadow: none;
} */
.schedule_page {
  width: 100%;
  display: block;
  margin-bottom: 20px;
}
/* .page_open {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  cursor: pointer;
} */
.page_open img {
  width: 100%;
}
.page_close {
  display: block;
  text-align: center;
  margin: 30px auto 0;
  width: 400px;
  padding: 30px 0;
  background-color: #335cb0;
  color: #fff;
  font-weight: bold;
  border-radius: 10px;
  cursor: pointer;
  transition: 0.3s;
  font-size: 1.2rem;
}
.page_close:hover {
  background-color: #244484;
}
.battletrip_tour img{
  cursor: pointer;
}



/*------------tab2-------------*/
.page_close2 {
  display: block;
  text-align: center;
  margin: 30px auto 0;
  width: 400px;
  padding: 30px 0;
  background-color: #f14f48;
  color: #fff;
  font-weight: bold;
  border-radius: 10px;
  cursor: pointer;
  transition: 0.3s;
  font-size: 1.2rem;
}
.page_close2:hover {
  background-color: #982924;
}
.battletrip_schedule_wrap2{
  position: relative;
  width: 100%;
  height: 300px;
}
.battletrip_schedule2 {
  width: 1000px;
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%);
  display: flex;
  justify-content: space-between;
}
.schedule_box2 {
  display: block;
  width: 332px;
  height: 80px;
  background-color: #f14f48;
  text-align: center;
  padding-top: 1.5rem;
  font-size: 1.2rem;
  font-weight: bold;
  color: #fff;
  border-radius: 10px;
  transition: all 0.3s;
}
.schedule_box2:hover {
  background-color: #8d1e1b;
}
.schedule_box2.active {
  background-color: #7a1f1a;
}
.battletrip_schedule_page_wrap2 {
  width: 700px;
  position: relative;
  margin: 0 auto;
  background-color: #f14f48;
  height: auto;
  overflow: visible;
  box-shadow: 2px 2px 5px 0px rgba(0, 0, 0, 0.5);
  margin-bottom: 150px;
}
/* .battletrip_schedule_page_wrap2.open {
  height: auto;
  overflow: visible;
  background-color: transparent;
  box-shadow: none;
} */
.schedule_page2 {
  width: 100%;
  display: block;
  margin-bottom: 20px;
}
.battletrip_bottom_go{
  width: 100%;
  margin-bottom: 100px;
}
.battletrip_bottom_go a{
  text-align: center;
  margin: 0 auto;
  height: 80px;
  width: 300px;
  color: #fff;
  display: block;
  background-color: #335cb0;
  font-weight: bold;
  font-size: 1.2rem;
  padding-top: 1.5rem;
  border-radius: 10px;
  transition: all 0.3s;
}
.battletrip_bottom_go a:hover{
  background-color: #244484;
}

.main_mo{
    display: none;
  }

@media (max-width: 767px) {
  #Battletrip{
  margin-top: 0px;
}

  /* 메인 이미지 */
  .battletrip_main_img_wrap img {
    width: 100%;
    height: auto;
  }

  /* 상단 카테고리 */
  .battletrip_top_category_wrap {
    height: 90px;
  }

  .battletrip_top_category {
    width: 100%;
    height: 90px;
  }

  .battletrip_top_category a {
    width: 50%;
    height: 90px;
    font-size: 1rem;
    padding-top: 0.8rem;
  }

  .battletrip_top_category a:hover {
    background-color: #244484;
  }

  /* 섹션 1 포인트 이미지 */
  .battletrip_point_wrap {
    width: 100%;
    height: auto;
  }
  .section1_bg{
    height: 600px;
    object-fit: cover;
  }
  .battletrip_point {
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
    top: 25%;
  }
  .battletrip_point img:hover{
  transform: initial;
}

  .battletrip_point img {
    width: 35%;
    margin: 10px 10px;
  }

  .section1_title {
    position: absolute;
    top: 10%;
    left: 50%;
    transform: translateX(-50%);
    width: 70%;
  }

  .section1_bg {
    width: 100%;
  }

  /* 섹션 2 지도 */
  .battletrip_map_wrap {
    position: relative;
    width: 100%;
  }

  .section2_left {
    display: none;
  }

  /* 섹션 3 투어 이미지 */
  .section3_title{
    width: 50%;
  }
  .battletrip_tour_wrap {
    height: 950px;
    margin-top: 150px;
  }
  .battletrip_tour{
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    top: 20%;
    margin: 20px 0;
  }
  .battletrip_tour img {
    width: 45%;
    height: auto;
    flex-wrap: wrap;
    padding: 5px 0;
  }

  /* 일정 박스 */
  .battletrip_schedule_wrap {
    height: 138px;
    padding: 20px 0;
  }
.section4_title{
  width: 60%;
  top: -20%;
}

  .battletrip_schedule {
    flex-direction: wrap;
    width: 100%;
    top: 35%;
  }

  .schedule_box {
    width: 90%;
    margin: 10px auto;
    font-size: 0.9rem;
    border-radius: 0px;
    padding-top: 1.2rem;
  }

  .battletrip_schedule_page_wrap {
    width: 100%;
    margin: 0;
    box-shadow: none;
    height: auto;
  }

  .schedule_page {
    width: 100%;
    margin-bottom: 20px;
  }

/*   .page_open img {
    width: 100%;
  } */
/* 
  .page_close {
    width: 90%;
    padding: 20px;
    font-size: 1rem;
  }
 */
/*   .battletrip_schedule_page_wrap.open {
    background-color: transparent;
  } */

  /* 카멜리아 부분 */
  .battletrip_schedule_wrap2 {
    height: 138px;
    padding: 20px 0;
  }

  .battletrip_schedule2 {
    flex-direction: wrap;
    width: 100%;
    top: 35%;
  }

  .schedule_box2 {
    width: 90%;
    margin: 10px auto;
    font-size: 0.9rem;
    border-radius: 0px;
    padding-top: 1.2rem;
    vertical-align: middle;
  }

  .battletrip_schedule_page_wrap2 {
    width: 100%;
    margin: 0;
    box-shadow: none;
    height: auto;
  }

  .schedule_page2 {
    width: 100%;
    margin-bottom: 20px;
  }

  .page_close2 {
    width: 90%;
    padding: 20px;
    font-size: 1rem;
  }
  .battletrip_bottom_go{
    margin-top: 100px;
  }
  .main_pc{
    display: none;
  }
  .main_mo{
    display: block;
  }
  .bferry .main_mo{
    transform: translate(0,30%);
    margin-top: -147px;
  }
  .cferry .main_mo{
    transform: translate(0,30%);
    margin-top: -147px;
  }
  .mo_button{
    width: 100%;
  }
  .mo_no{
    display: none;
  }
  .schedule_page_margin{
    margin: 50px auto;
  }
  .map_margin_top{
    margin-top: 100px;
  }
}
</style>
